export default __webpack_public_path__ + "images/N1.27b6cba.png";